import React from 'react';
import { Modal, Card } from 'semantic-ui-react';
import { paymentTypes } from '../data/payment-types';
export default function PeriodSelect(_ref) {
  var currentPlanIndex = _ref.currentPlanIndex,
      onPeriodSelected = _ref.onPeriodSelected;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "modal-header"
  }, "Select a subscription period"), /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement("h2", {
    className: "header-text blue-color"
  }, paymentTypes[currentPlanIndex].title), /*#__PURE__*/React.createElement("div", {
    className: "period-select-container"
  }, /*#__PURE__*/React.createElement(Card, {
    className: "period-card",
    onClick: function onClick() {
      return onPeriodSelected(true);
    }
  }, /*#__PURE__*/React.createElement(Card.Content, null, /*#__PURE__*/React.createElement("h2", {
    className: "blue-color left-aligned"
  }, "Annually"), /*#__PURE__*/React.createElement("div", {
    className: "annual-period-card"
  }, /*#__PURE__*/React.createElement("p", {
    className: "annual-period-card-first"
  }, paymentTypes[currentPlanIndex].annual.description), /*#__PURE__*/React.createElement("h3", {
    className: "green-color annual-period-card-second"
  }, "SAVE $", paymentTypes[currentPlanIndex].monthly.price * 2)), /*#__PURE__*/React.createElement("p", {
    className: "left-aligned body-text"
  }, "Billed as one payment of $", paymentTypes[currentPlanIndex].annual.price)))), /*#__PURE__*/React.createElement("div", {
    className: "period-select-container"
  }, /*#__PURE__*/React.createElement(Card, {
    className: "period-card",
    onClick: function onClick() {
      return onPeriodSelected(false);
    }
  }, /*#__PURE__*/React.createElement(Card.Content, null, /*#__PURE__*/React.createElement("div", {
    className: "annual-period-card-first"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "blue-color"
  }, "Monthly"), /*#__PURE__*/React.createElement("p", null, paymentTypes[currentPlanIndex].monthly.description)))))));
}